import React, {useMemo} from 'react'
import styles from './UIGameTradeOfferHeader.module.scss'
import clsx from 'clsx'
import {Avatar} from '../../../common/Avatar'
import IconArrowDown from '@static/images/icon_arrow_down_black.svg'
import IconArrowUp from '@static/images/icon_arrow_up_black.svg'
import {TradeEmbargoControllerReader} from '@colonist/game-base-types'
import {PlayerColor} from '@colonist/game-states'
import {useGameStore} from '../../../store/GameStoreContext'
import {usePlayerValidators} from '../../../store/selectors/usePlayerValidators'
import {useCurrentStateValidator} from '../../../store/selectors/useCurrentStateValidator'
import {PlayerValidator} from '@colonist/game-mechanic-validators'

export interface UIGameTradeOfferHeaderProps {
    className?: string | undefined
    isShowingTrade?: boolean
    onShowHideTradeClick: () => void
}

export const UIGameTradeOfferHeader = ({
    className,
    isShowingTrade,
    onShowHideTradeClick,
}: UIGameTradeOfferHeaderProps) => {
    const tradeState = useGameStore((state) => state.gameState.tradeState)
    const {playerValidators, getPlayerValidator} = usePlayerValidators()
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)
    const myColor = useGameStore((state) => state.myColor)
    const onClickToggleEmbargoAgainstPlayer = useGameStore((state) => state.gameTrade.onClickToggleEmbargoAgainstPlayer)
    const currentStateValidator = useCurrentStateValidator()
    const isMyTurn = currentStateValidator.currentTurnPlayers.includes(myColor)

    const players = useMemo(() => {
        if(isMyTurn) return playerValidators.filter((player) => player.color !== myColor)
        const currentTurnPlayers: PlayerValidator[] = []
        for(const player of currentStateValidator.currentTurnPlayers) {
            currentTurnPlayers.push(getPlayerValidator(player))
        }
        return currentTurnPlayers
    }, [isMyTurn, playerValidators, myColor])

    const handleClick = (color: PlayerColor) => {
        if(isMyColorSpectator) return
        onClickToggleEmbargoAgainstPlayer(color)
    }
    return (
        <div className={clsx(styles.container, className)}>
            {players.map((player) => {
                const isEmbargoed = TradeEmbargoControllerReader
                    .doesPlayer1HaveAnEmbargoAgainstPlayer2(tradeState.embargoState, myColor, player.color)
                return (
                    <Avatar
                        isEmbargoed={isEmbargoed}
                        key={player.color}
                        color={player.color}
                        image={player.userState.databaseIcon}
                        profilePictureUrl={player.userState.profilePictureUrl}
                        onClick={() => handleClick(player.color)}
                        className={styles.avatar}
                    />
                )
            })}
            <img
                src={isShowingTrade ? IconArrowDown : IconArrowUp}
                onClick={onShowHideTradeClick}
                className={styles.showHideTradeIcon} />
        </div>
    )
}
